import React, { useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles';
import { Grid, Box } from '@mui/material';
import { AiOutlineDownload } from 'react-icons/ai'
import { BsTelephoneOutbound } from 'react-icons/bs'
const SubPage = () => {
    const [Menupackage, setMenuPackage] = useState(true)
    const theme = useTheme()
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'))
    if (performance.navigation.type === 1) {
        // Page is being reloaded, so redirect to the home page
        window.location.href = '/';
    }

    const packageData = {
        monthly: [
            {
                id: '1',
                img: require('../../Assets/dosa_breakfast.webp'),
                packageName: 'Daybreak and Dinner Delights',
                packageType: '(Breakfast & Dinner)',
                // Cost: `${115}/day * 22days `,
                packageRate: 2530,
                delivery: '(including delivery charge)'
            },
            {
                id: '2',
                img: require('../../Assets/Veg-Pulao.jpg'),
                packageName: 'BrunchTime Bliss',
                packageType: '(Breakfast & Lunch)',
                // Cost: `${130}/day * 22days`,
                packageRate: 2860,
                delivery: '(including delivery charge)'
            },
            {
                id: '3',
                img: require('../../Assets/meals_lunch.jpg'),
                packageName: 'Lunch & Dinner Delights',
                packageType: '(Lunch & Dinner)',
                // Cost: `${130}/day * 22days`,
                packageRate: 2860,
                delivery: '(including delivery charge)'
            },
            {
                id: '4',
                img: require('../../Assets/tripleTasty.webp'),
                packageName: 'Triple Tasty Treats',
                packageType: '(Breakfast & Lunch & Dinner)',
                // Cost: `${163}/day * 22days`,
                packageRate: 3599,
                delivery: '(including delivery charge)'
            },
            {
                id: '4',
                img: require('../../Assets/tripleTasty.webp'),
                packageName: 'Mid Feast',
                packageType: '( Lunch )',
                // Cost: `${90}/day * 5days`,
                packageRate: 1870,
                delivery: '(including delivery charge)'
            },
        ],
        weekly: [
            {
                id: '1',
                img: require('../../Assets/dosa_breakfast.webp'),
                packageName: 'Daybreak and Dinner Delights',
                packageType: '(Breakfast & Dinner)',
                Cost: `${105}per day for 5days`,
                packageRate: 525
            },
            {
                id: '2',
                img: require('../../Assets/Veg-Pulao.jpg'),
                packageName: 'BrunchTime Bliss',
                packageType: '(Breakfast & Lunch)',
                Cost: `${120}per day for 5days`,
                packageRate: 600
            },
            {
                id: '3',
                img: require('../../Assets/meals_lunch.jpg'),
                packageName: 'Lunch & Dinner Delights',
                packageType: '(Lunch & Dinner)',
                Cost: `${120}per day for 5days`,
                packageRate: 600
            },
            {
                id: '4',
                img: require('../../Assets/tripleTasty.webp'),
                packageName: 'Triple Tasty Treats',
                packageType: '(Breakfast & Lunch & Dinner)',
                Cost: `${145} per day for 5days`,
                packageRate: 800
            },
            {
                id: '4',
                img: require('../../Assets/tripleTasty.webp'),
                packageName: 'Mid Feast',
                packageType: '( Lunch )',
                Cost: `${90}per day for 5days`,
                packageRate: 450
            },
        ]
    }

    const handleDownload = () => {
        // Construct the URL to the PDF file
        const pdfUrl = process.env.PUBLIC_URL + "/Mani's_Kitchen_Catalogue.pdf";

        // Create a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = pdfUrl;
        a.download = 'Catalogue.pdf';

        // Programmatically click the anchor element to initiate the download
        a.click();
    };

    return (
        <div>
            <div className='package-container'>
                <div style={{ backgroundColor: '#7ed957' }} className='text-center mt-4'>
                    <img src={require('../../Assets/PACKAGES_image.png')} alt='package_img' height={'80px'} />
                </div>
                {isMobileScreen ?
                    <></>
                    :
                    <div className='d-flex justify-content-center scrolling-text'>
                        <div className='d-flex align-items-center delivery '>
                            <main className='mx-2'>Free delivery upto 5km</main>
                            <img src={require('../../Assets/delivery_image.png')} alt='delivery_Image' width={'50px'} height={'50px'} />
                        </div>
                    </div>}
                <div>
                </div>
                {
                    isMobileScreen ?
                        <div className='mt-3'>
                            <div className=' text-center' style={{ margin: '0px 0px 30px 0px' }}>
                                <button className={`border-0  ${Menupackage ? 'bg-success text-white' : 'bg-secondary text-dark'} text-capitalize px-3 py-1 rounded-2 mx-2`} onClick={() => setMenuPackage(true)}>WEEKLY</button>
                                <button className={`border-0  ${Menupackage === false ? 'bg-success text-white' : 'bg-secondary text-dark'} text-capitalize px-3 py-1 rounded-2`} onClick={() => setMenuPackage(false)}>MONTHLY</button>
                            </div>
                            {Menupackage ?
                                <Grid container spacing={4}>
                                    {packageData.weekly.map((item, index) => {
                                        return (
                                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                <Box className="card border-0 shadow-sm rounded-4 h-100" component={"div"} width={"100%"}>
                                                    <Box component={'img'} src={item.img} className="card-img-top object-fit" width={"100%"} height={'150px'} alt="Image Not Available" borderRadius={'10px 10px 0px 0px'} />
                                                    <div className="card-body">
                                                        <div className='card-title d-flex justify-content-between'>
                                                            <main className="fw-bold" style={{ fontSize: '15px' }}>{item.packageName}</main>
                                                            <button className=' text-success border-0 p-0 bg-transparent' onClick={handleDownload}>Menu <AiOutlineDownload size={'25px'} /> </button>
                                                        </div>
                                                        <div className='d-flex gap-2 mt-2'>
                                                            <div style={{ fontSize: '15px' }}>PackageType:</div>
                                                            <div>{item.packageType}</div>
                                                        </div>
                                                        <div className='d-flex justify-content-between mt-2' >
                                                            <div className='d-flex gap-2 pt-2'>
                                                                <div style={{ fontSize: '15px' }}>Price:</div>
                                                                <div className='fw-bold'>₹{item.packageRate}</div>
                                                            </div>
                                                            <div>
                                                                <a href='tel:9360944349'><button className='mt-2 border-0 rounded-1 text-white bg-success'>Order <BsTelephoneOutbound size={'15px'} /> </button></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-footer'>
                                                        <main className='text-center  text-'>Cost : {item?.Cost}</main>
                                                    </div>
                                                </Box>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                                :
                                <Grid container spacing={4}>
                                    {packageData.monthly.map((item, index) => {
                                        return (
                                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                <Box className="card border-0 shadow-sm rounded-4 h-100" component={"div"} width={"100%"} >
                                                    <Box component={'img'} src={item.img} className="card-img-top object-fit" width={"100%"} height={'150px'} alt="Image Not Available" borderRadius={'10px 10px 0px 0px'} />
                                                    <div className="card-body">
                                                        <div className='card-title d-flex justify-content-between'>
                                                            <main className="fw-bold" style={{ fontSize: '15px' }}>{item.packageName}</main>
                                                            <button className=' text-success border-0 p-0 bg-transparent' onClick={handleDownload}>Menu <AiOutlineDownload size={'25px'} /> </button>
                                                        </div>
                                                        <div className='d-flex gap-2'>
                                                            <div style={{ fontSize: '15px' }}>PackageType:</div>
                                                            <div>{item.packageType}</div>
                                                        </div>
                                                        <div className='d-flex gap-3 justify-content-between mt-2' >
                                                            <div className='d-flex gap-2 pt-2'>
                                                                <div style={{ fontSize: '15px' }}>Price:</div>
                                                                <div className='fw-bold'>₹{item.packageRate}</div>
                                                            </div>
                                                            <div>
                                                                <a href='tel:9360944349'><button className='mt-2 border-0 rounded-1 text-white bg-success'>Order <BsTelephoneOutbound size={'15px'} /> </button></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='card-footer'>
                                                        <main className='text-center'>{item.delivery}</main>
                                                    </div>
                                                </Box>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            }
                        </div> :
                        <>
                            <h5 className='text-white bg-secondary text-capitalize px-3 py-1 rounded-2' style={{ width: 'fit-content', margin: '50px 0px' }}>weekly Plans ~</h5>
                            <Grid container spacing={4}>
                                {packageData.weekly.map((item, index) => {
                                    return (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <Box className="card border-0 shadow-sm rounded-4 h-100" component={"div"} width={"100%"}>
                                                <Box component={'img'} src={item.img} className="card-img-top object-fit" width={"100%"} height={'150px'} alt="Image Not Available" borderRadius={'10px 10px 0px 0px'} />
                                                <div className="card-body">
                                                    <div className='card-title d-flex justify-content-between'>
                                                        <main className="fw-bold" style={{ fontSize: '15px' }}>{item.packageName}</main>
                                                        <button className=' text-success border-0 p-0 bg-transparent' onClick={handleDownload}>Menu <AiOutlineDownload size={'25px'} /> </button>
                                                    </div>
                                                    <div className='d-flex gap-2 mt-2'>
                                                        <div style={{ fontSize: '15px' }}>PackageType:</div>
                                                        <div>{item.packageType}</div>
                                                    </div>
                                                    <div className='d-flex justify-content-between mt-2' >
                                                        <div className='d-flex gap-2 pt-2'>
                                                            <div style={{ fontSize: '15px' }}>Price:</div>
                                                            <div className='fw-bold'>₹{item.packageRate}</div>
                                                        </div>
                                                        <div>
                                                            <a href='tel:9360944349'><button className='mt-2 border-0 rounded-1 text-white bg-success'>Order <BsTelephoneOutbound size={'15px'} /> </button></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-footer'>
                                                    <main className='text-center  text-'>Cost : {item?.Cost}</main>
                                                </div>
                                            </Box>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                            <h5 className='text-white bg-secondary px-3  py-1 mt-4 rounded-2' style={{ width: 'fit-content', margin: '50px 0px' }}>Monthly Plans ~</h5>
                            <Grid container spacing={4} className='pb-5'>
                                {packageData.monthly.map((item, index) => {
                                    return (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <Box className="card border-0 shadow-sm rounded-4 h-100" component={"div"} width={"100%"} >
                                                <Box component={'img'} src={item.img} className="card-img-top object-fit" width={"100%"} height={'150px'} alt="Image Not Available" borderRadius={'10px 10px 0px 0px'} />
                                                <div className="card-body">
                                                    <div className='card-title d-flex justify-content-between'>
                                                        <main className="fw-bold" style={{ fontSize: '15px' }}>{item.packageName}</main>
                                                        <button className=' text-success border-0 p-0 bg-transparent' onClick={handleDownload}>Menu <AiOutlineDownload size={'25px'} /> </button>
                                                    </div>
                                                    <div className='d-flex gap-2'>
                                                        <div style={{ fontSize: '15px' }}>PackageType:</div>
                                                        <div>{item.packageType}</div>
                                                    </div>
                                                    <div className='d-flex gap-3 justify-content-between mt-2' >
                                                        <div className='d-flex gap-2 pt-2'>
                                                            <div style={{ fontSize: '15px' }}>Price:</div>
                                                            <div className='fw-bold'>₹{item.packageRate}</div>
                                                        </div>
                                                        <div>
                                                            <a href='tel:9360944349'><button className='mt-2 border-0 rounded-1 text-white bg-success'>Order <BsTelephoneOutbound size={'15px'} /> </button></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-footer'>
                                                    <main className='text-center'>{item.delivery}</main>
                                                </div>
                                            </Box>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </>
                }
            </div>
        </div>
    )
}

export default SubPage